// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"645b167e","475":"57c6e732","525":"edeffa25","874":"fc31fb7a","946":"3156b317"}[chunkId] + ".chunk.css";
};